<div>
  <a
    class="btn btn-light btn-circle"
    i18n-matTooltip
    matTooltip="View a chronological list of events that updates in real time."
    matTooltipPosition="below"
    (click)="onShown()"
  >
    <i class="fal fa-bell text-lg"></i>
    <sup [hidden]="!unreadCount" class="badge">{{ unreadCount }}</sup>
  </a>
</div>
